import { useContext, useEffect, useState } from 'react'

import { useHistory, useLocation } from 'react-router-dom'

import SchoolRequesterForm from './SchoolRequesterForm'
import AppLoading from '../../Components/shared/AppLoading'
import InternshipRequestPortalFormProvider, { Modes } from '../../Providers/Forms/InternshipRequestPortal/InternshipRequestPortalFormProvider'
import { RequestPortalContext } from '../../Providers/RequestPortalProvider'
import { Routes } from '../../routes'
import PortalLayout, { REQUESTER_STYLE } from './PortalLayout'
import RedirectToLoginCountdown from './RedirectToLoginCountdown'
import { getPortalAddressee, getPortalOwnerName } from '../../utils/api/internshipRequestPortal'
import usePortalResolution from './usePortalResolution'

const Phases = Object.freeze({
  REQUESTER: 0,
  WIZARD: 1
})

const InternshipRequestPortalSchool = () => {
  const { setInstitution, setPortalAccessKey } = useContext(RequestPortalContext)

  const location = useLocation()
  const history = useHistory()

  const { portalData, errorMessage, loadedLanguageTag, isResolved } = usePortalResolution()

  const [phase, setPhase] = useState(Phases.REQUESTER)
  const [isRedirecting, setIsRedirecting] = useState(false)

  useEffect(() => {
    setPhase(Phases.REQUESTER)
  }, [location.pathname])

  const handleHasAccount = () => {
    setInstitution(portalData.institution)
    setPortalAccessKey(portalData.accessKey)
    setIsRedirecting(true)
  }

  if (loadedLanguageTag.length === 0 && (portalData.institution === null || portalData.institutionGroup === null)) {
    return <AppLoading />
  }

  const isRequesterPhase = phase === Phases.REQUESTER
  const isRequesterCard = isRequesterPhase || isRedirecting

  return (
    <PortalLayout
      portalData={portalData}
      errorMessage={errorMessage}
      displayInstitution={!isRequesterCard}
      style={isRequesterCard ? REQUESTER_STYLE : undefined}
      title='school_portal.title'
    >
      {isRedirecting && (
        <RedirectToLoginCountdown onRedirect={() => history.push(Routes.LOGIN)} />
      )}

      {isResolved && !isRedirecting && (
        <InternshipRequestPortalFormProvider
          institutionGroup={portalData.institutionGroup}
          institution={portalData.institution}
          portalAccessKey={portalData.accessKey}
          initialMode={Modes.SCHOOL}
          visible={phase === Phases.WIZARD}
          onHasAccount={handleHasAccount}
          onReset={() => setPhase(Phases.REQUESTER)}
          Wrapper={(({ children }) => <div>{children}</div>)}
        >
          <SchoolRequesterForm
            addressee={getPortalAddressee(portalData)}
            institutionName={getPortalOwnerName(portalData)}
            portalAccessKey={portalData.accessKey}
            visible={isRequesterPhase}
            onAllowed={() => setPhase(Phases.WIZARD)}
            onHasAccount={handleHasAccount}
          />
        </InternshipRequestPortalFormProvider>
      )}
    </PortalLayout>
  )
}

export default InternshipRequestPortalSchool
